import { Stack } from "@mui/material";
import TextInput from "../../../components/files/TextInput";
import { celIsraeli } from "../../../utils/validations";
import NullCheck from "../../../components/NullCheck";

const ClientDetails = ({ errors, control, data }) => {
  return (
    <Stack spacing={2}>

      <NullCheck valueForCheck={!data?.miniSite?.hideClientCallId}>
        <TextInput
          width={{ xs: "100%", md: "auto" }}
          errors={errors}
          name="clientCallId"
          title="CLIENT_CALL_ID"
          control={control}
        />
      </NullCheck>

      <TextInput
        width={{ xs: "100%", md: "auto" }}
        required
        errors={errors}
        name="name"
        title="NAME"
        control={control}
      />
      <TextInput
        width={{ xs: "100%", md: "auto" }}
        required
        errors={errors}
        validation={celIsraeli}
        name="tel"
        title="TEL"
        control={control}
      />
      <TextInput
        width={{ xs: "100%", md: "auto" }}
        errors={errors}
        name="addr"
        title="ADDR"
        control={control}
      />
    </Stack>
  );
};
export default ClientDetails;
